import styled from '@emotion/styled';
import Grid from '@react-css/grid';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppSelector } from 'store';
import {
  selectIsBuyer,
  selectIsDropshipSetup,
  selectIsOrderPlatformShopify,
} from 'store/selectors/me/company';
import Card from 'storybookConfig/stories/cells/Card';
import Menu from 'storybookConfig/stories/cells/Menu';

const MenuWrapper = styled(Card)`
  padding: 24px;
  position: sticky;
  top: 24px;
`;

enum SectionSegments {
  Billing = 'billing',
  Shipping = 'shipping',
  Integrations = 'integrations',
  Webhooks = 'webhooks',
  Notifications = 'notifications',
  Merchandising = 'merchandising',
  ServiceLevels = 'service-levels',
  Returns = 'returns',
}

const Dropshipping = () => {
  const { pathname } = useLocation();
  const section = pathname.split('/')[3] as SectionSegments | undefined;

  const isBuyer = useAppSelector(selectIsBuyer);
  const isOrderPlatformShopify = useAppSelector(selectIsOrderPlatformShopify);
  const isDropshipSetup = useAppSelector(selectIsDropshipSetup);

  const selectedSection =
    section && Object.values(SectionSegments).includes(section) ? section : SectionSegments.Billing;
  if (!isDropshipSetup) {
    return <Navigate to="/settings/preferences/account" replace />;
  }
  return (
    <Grid columns="240px 1fr" gap="24px">
      <Grid.Item>
        <MenuWrapper>
          <Menu>
            <Menu.Link
              $iconName="monetization_on"
              $isActive={selectedSection === SectionSegments.Billing}
              to="/settings/dropshipping/billing"
            >
              Billing
            </Menu.Link>

            <Menu.Link
              $iconName="local_shipping"
              $isActive={selectedSection === SectionSegments.Shipping}
              to="/settings/dropshipping/shipping"
            >
              Shipping
            </Menu.Link>

            <Menu.Link
              $iconName="sync_alt"
              $isActive={selectedSection === SectionSegments.Integrations}
              to="/settings/dropshipping/integrations"
            >
              Integrations
            </Menu.Link>

            <Menu.Link
              $iconName="webhook"
              $isActive={selectedSection === SectionSegments.Webhooks}
              to="/settings/dropshipping/webhooks"
            >
              Webhooks
            </Menu.Link>

            <Menu.Link
              $iconName="notifications"
              $isActive={selectedSection === SectionSegments.Notifications}
              to="/settings/dropshipping/notifications"
            >
              Notifications
            </Menu.Link>

            {isBuyer && (
              <Menu.Link
                $iconName="point_of_sale"
                $isActive={selectedSection === SectionSegments.Merchandising}
                to="/settings/dropshipping/merchandising"
              >
                Merchandising
              </Menu.Link>
            )}

            {isBuyer && (
              <Menu.Link
                $iconName="receipt_long"
                $isActive={selectedSection === SectionSegments.ServiceLevels}
                to="/settings/dropshipping/service-levels"
              >
                Service Levels
              </Menu.Link>
            )}

            {isOrderPlatformShopify && (
              <Menu.Link
                $iconName="assignment_return"
                $isActive={selectedSection === SectionSegments.Returns}
                to="/settings/dropshipping/returns"
              >
                Returns
              </Menu.Link>
            )}
          </Menu>
        </MenuWrapper>
      </Grid.Item>

      <Card>
        <Outlet />
      </Card>
    </Grid>
  );
};

export default Dropshipping;
